import _stubTrue2 from "lodash/stubTrue";
import React from 'react';
import { FilterHoverProductsListingIcon } from 'swag-client-common/components/svg/filter-hover-products-listing.svg';
import { FilterProductsListingIcon } from 'swag-client-common/components/svg/filter-products-listing.svg';
import { CustomizableIconButton } from 'swag-client-common/components/ui/customizable-icon-button/customizable-icon-button';
import classes from './filter-button.scss';
export const FilterButton = ({
  onClick,
  primaryColor,
  secondaryColor
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(CustomizableIconButton, {
    label: "Filters",
    dataButton: "Filters",
    dataTooltip: "Filters",
    tooltipDirection: "right",
    iconClassName: classes.icon,
    buttonClassName: classes.button,
    tooltipClassName: classes.tooltip,
    labelClassName: classes.label,
    onClick: _stubTrue2,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    PrimaryIcon: FilterProductsListingIcon,
    SecondaryIcon: FilterHoverProductsListingIcon
  }));
};